// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"494":"f82a23039a8af1db","838":"a25e6458ecfb3733"}[chunkId] + ".js";
};